import React from 'react'
import { useHistory } from 'react-router-dom'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconAdd } from '../../../../../shared/icon/icon'
import { Form, FormText, FormSubmitCancel } from '../../../../../shared/form/form'
import { FormSelectGroupID } from '../../../../../shared/form/form-control/form-select-group-id'
import { Card } from '../../../../../shared/card/card'
import { useApFormSelfRegister } from '../../../../../api-new/state/content'
import { useRoleOrgTradeshow } from '../../../../../role/hook/role-org'

export const SelfRegisterAdd = () => {
  const history = useHistory()

  const apFormSelfRegister = useApFormSelfRegister()

  const roleOrgTradeshow = useRoleOrgTradeshow()

  const handleSubmit = async data => {
    let selfRegister = await apFormSelfRegister.post(data)
    if (roleOrgTradeshow.accessUpdate) history.push(`/org/self-register/list/edit/${selfRegister.id}`)
    else history.push(`/org/self-register/list`)
  }

  const handleCancel = () => history.push('/org/self-register/list')

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="Add self register">
        <Card title="Add self register">
          <Form submitting={apFormSelfRegister.submitting} onSubmit={handleSubmit}>
            <FormText label="name" name="name" required />
            <FormSelectGroupID label="group" name="groupID" required />
            <FormSubmitCancel text="add self register" onCancel={handleCancel} />
          </Form>
        </Card>
      </BreadcrumbView>
    </React.Fragment>
  )
}
